import Link from "next/link";
import React from "react";
import { css } from "styled-components";
import {
  FreeFortuneCategory,
  FreeFortuneContent,
  FreeFortuneDivination,
  FreeFortuneResultContent,
  FreeFortuneTag,
} from "shared/types";
import tw from "twin.macro";
import { useFreeFortuneDivinationNameAlias } from "features/無料占いコンテンツ/hooks/useFreeFortuneDivinationNameAlias";

const Item = tw.li`font-normal text-xs leading-[19px] text-[#cf73b2] tracking-[.3px] mr-1`;

interface Props {
  freeFortuneContent?: FreeFortuneContent;
  freeFortuneResultContent?: FreeFortuneResultContent;
  freeFortuneCategory?: FreeFortuneCategory;
  freeFortuneTag?: FreeFortuneTag;
  freeFortuneDivination?: FreeFortuneDivination;
  className?: string;
}

export const BreadCrumb = ({
  freeFortuneContent,
  freeFortuneResultContent,
  freeFortuneCategory,
  freeFortuneDivination,
  freeFortuneTag,
  className,
}: Props) => {
  const { alias } = useFreeFortuneDivinationNameAlias(
    freeFortuneContent?.freeFortuneDivination
  );

  return (
    <ol
      tw="flex overflow-x-auto whitespace-nowrap"
      css={css({ "::-webkit-scrollbar": { display: "none" } })}
      className={className}
    >
      <Item>
        <Link href="/">
          <a>チャット占い・電話占い</a>
        </Link>
      </Item>
      <Item>
        <Link href="/free_fortune">
          <a>{`> 無料占い`}</a>
        </Link>
      </Item>
      {freeFortuneCategory && !freeFortuneDivination && (
        <>
          <Item>
            <Link href={`/free_fortune/category/${freeFortuneCategory.id}`}>
              <a>{`> ${freeFortuneCategory.name}占い`}</a>
            </Link>
          </Item>
        </>
      )}
      {freeFortuneCategory && freeFortuneDivination && (
        <>
          <Item>
            <Link href={`/free_fortune/type/${freeFortuneDivination.id}`}>
              <a>{`> ${freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
          <Item>
            <Link
              href={`/free_fortune/category/${freeFortuneCategory.id}/type/${freeFortuneDivination.id}`}
            >
              <a>{`> ${freeFortuneCategory.name}${freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
        </>
      )}
      {freeFortuneTag && !freeFortuneDivination && (
        <>
          <Item>
            <Link href={`/free_fortune/tag/${freeFortuneTag.id}`}>
              <a>{`> ${freeFortuneTag.name}占い`}</a>
            </Link>
          </Item>
        </>
      )}
      {freeFortuneTag && freeFortuneDivination && (
        <>
          <Item>
            <Link href={`/free_fortune/type/${freeFortuneDivination.id}`}>
              <a>{`> ${freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
          <Item>
            <Link
              href={`/free_fortune/category/${freeFortuneTag.id}/type/${freeFortuneDivination.id}`}
            >
              <a>{`> ${freeFortuneTag.name}${freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
        </>
      )}
      {!freeFortuneTag && !freeFortuneCategory && freeFortuneDivination && (
        <>
          <Item>
            <Link href={`/free_fortune/type/${freeFortuneDivination.id}`}>
              <a>{`> ${freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
        </>
      )}
      {freeFortuneContent && (
        <>
          <Item>
            <Link
              href={`/free_fortune/type/${freeFortuneContent.freeFortuneDivination.id}`}
            >
              <a>{`> 無料${freeFortuneContent.freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
          <Item>
            <Link
              href={`/free_fortune/tag/${freeFortuneContent.primaryTags[0].id}/type/${freeFortuneContent.freeFortuneDivination.id}`}
            >
              <a>{`> ${freeFortuneContent.primaryTags[0].name}${freeFortuneContent.freeFortuneDivination.name}占い`}</a>
            </Link>
          </Item>
          <Item>
            <Link href={`/free_fortune/${alias}/${freeFortuneContent.id}`}>
              <a>{`> ${freeFortuneContent?.title}`}</a>
            </Link>
          </Item>
          {freeFortuneResultContent && (
            <Item>
              <a>{`> 《鑑定結果》${freeFortuneResultContent?.title}`}</a>
            </Item>
          )}
        </>
      )}
    </ol>
  );
};
